import { EventTypes, track } from '@mc/track-event'

const getEventName = (hasEpisode: boolean) =>
  hasEpisode ? EventTypes.EPISODE_PAGE_CLICK : EventTypes.COURSE_MARKETING_CLICK

export const trackAllCategoriesBreadcrumbClick = (hasEpisode: boolean) => {
  track(getEventName(hasEpisode), {
    category: 'category',
    location: 'breadcrumbs',
    action: 'All Categories',
  })
}

export const trackPrimaryBreadcrumbClick = (
  slug: string,
  primaryCategoryName: string,
  hasEpisode: boolean,
) => {
  track(getEventName(hasEpisode), {
    category: 'category',
    location: 'breadcrumbs',
    action: primaryCategoryName,
    [hasEpisode ? 'episode' : 'course']: slug,
  })
}

export const trackSubcatBreadcrumbClick = (
  slug: string,
  primarySubcategoryName: string,
  hasEpisode: boolean,
) => {
  track(getEventName(hasEpisode), {
    category: 'subcategory',
    location: 'breadcrumbs',
    action: primarySubcategoryName,
    [hasEpisode ? 'episode' : 'course']: slug,
  })
}

export const trackSeriesBreadcrumbClick = (
  slug: string,
  seriesName: string,
  hasEpisode: boolean,
) => {
  track(getEventName(hasEpisode), {
    category: 'series',
    location: 'breadcrumbs',
    action: seriesName,
    [hasEpisode ? 'episode' : 'course']: slug,
  })
}
